var Vendd = (function (Vendd) {
    'use strict';
    /*
     * ERROR CODE
     * ---------------
     * 1000     INVALID CONFIGURATOR ITEM ID
     * 1001     CONFIGURATOR NOT FOUND / INITIALIZED
     * 1002     INVALID CONFIGURATOR MODEL DATA
     * 1003     INVALID OPTIONAL ITEM ID
     * 1004     INVALID CONFIGURATOR VALUES 
     * 1010     MIN QUANTITY OF OPTIONAL ITEM
     * 1011     MAX QUANTITY OF OPTIONAL ITEM
     * 1012     DEFAULT OPTIONAL ITEM CAN NOT REMOVE
     * 1020     MIN QUANTITY FOR GROUP OF OPTIONAL ITEMS
     * 1021     MAX QUANTITY FOR GROUP OF OPTIONAL ITEMS
     * 1040     MIN QUANTITY FOR ALL ITEMS
     * 1041     MAX QUANTITY FOR ALL ITEMS
     * 1030     INCOMATIBLE OPTIONAL ITEM
     * 1031     PREREQUISITES FOR OPTIONAL ITEM NOT EXIST
     * 1032     ERROR CODE 1030 & ERROR CODE 1031
     * 1033     NOT EXISTS ANY OF REQUIRED INGREDIENTS
     * 1034     INGREDIENT DISABLED FROM SELECTED SUBRECIPE
     * 1035     INGREDIENT DISABLED FROM MASTER RECIPE
     * 1050     NO LOCAL STORAGE CONFIGURATOR MODEL SAVED
     * 1060     ERROR SAVING DATA
     * 1061     ERROR SAVING DATA - NOT SET CONFIGURATOR ITEM ID
     * 1070     OUTDATED LOADED DATA
     * 1071     ERROR LOADING DATA - NOT GLOBALID SET
     * 1072     ERROR LOADING DATA - SAVED INGREDIENT DOES NOT EXISTS ANY MORE
     * 1073     ERROR LOADING DATA - SAVED INGREDIENT CHANGE PRICE
     * 1074     ERROR LOADING DATA - SAVED INGREDIENT CHANGE INCOMPATIBLES
     * 1075     ERROR LOADING DATA - SAVED INGREDIENT CHANGE PREREQUISITES
     * */
    var _recipes = {};
    var _recipesOld = {};
    var returnResponse = function (recipeId, statusCode, errorCode, data) {


        return {
            success: statusCode === 200,
            data: data || {},
            status: {
                statusCode: statusCode,
                recipeId: recipeId,
                ErrorCode: errorCode || 0
            }
        }
    };

    var getRecipe = function (model, recipeId) {

        var recipeModel = model ? model : testModel,
            recipe = _.isArray(recipeModel) ? _.first(_.filter(recipeModel, function (x) { return x.RecipeId === recipeId && x.TotalCount > 0; })) : recipeModel;

        return $.extend(true, {}, recipe);
    };

    var getTotalQuantity = function (model, ingredientId) {
        var items = _.filter(model.RecipeItems, function (item) { return item.IngredientId !== ingredientId; });
        return _.reduce(items, function (memo, item) { return memo + (item.Quantity || 0); }, 0);
    }

    var getGroupQuantity = function (model, group, ingredientId) {
        var items = _.filter(model.RecipeItems, function (item) { return item.GroupId === group.Id && item.IngredientId !== ingredientId; });
        return _.reduce(items, function (memo, item) { return memo + (item.Quantity || 0); }, 0);
    }

    var getTotalWeight = function (model, ingredientId) {
        var items = _.filter(model.RecipeItems, function (item) { return item.IngredientId !== ingredientId; });
        return _.reduce(items, function (memo, item) { return memo + (item.Weight || 0); }, 0);
    }
    Vendd.RecipeLibrary = Vendd.RecipeLibrary || {};

    Vendd.RecipeLibrary.DeclareState = function (model, recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }
        _recipes[recipeId] = model;
        var data = {};
        data.recipe = $.extend(true, {}, model);
        data.isValid = checkRestrictions(model);
        return returnResponse(recipeId, 200, 0, data);
    };

    Vendd.RecipeLibrary.GetModel = function (recipeId) {

        if (!_recipes[recipeId]) {
            return returnResponse(recipeId, 500, 1000);
        }

        return returnResponse(recipeId, 200, 0, _recipes[recipeId]);
    };

    Vendd.RecipeLibrary.InitRecipe = function (model, recipeId, force) {
        force = force || false;
        if (_recipes[recipeId] && !force) {
            return returnResponse(recipeId, 500, 1000);
        }
        var recipe = getRecipe(model, recipeId);
        if (!recipe) {
            return returnResponse(recipeId, 500, 1001);
        }
        _recipes[recipeId] = recipe;
        _recipes[recipeId].AFirstInclusion = 1;

        _recipes[recipeId].Ingredients = [];
        _recipes[recipeId].Groups = [];
        _recipes[recipeId].RecipeItems = [];

        $.each(recipe.Categories, function (indexCategory, category) {
            $.each(category.Groups, function (indexGroup, group) {
                $.each(group.VisualGroups, function (indexGroup, visualgroup) {
                    var groupItems = _.reduce(visualgroup, function (vg, sum) { return vg.length + sum; });
                    group.IsMultiSelect = !(group.MinQuantity <= 1 && group.MaxQuantity === 1 && groupItems > 1);
                    group.DefaultQuantities = 0;

                    if (!group.IsMultiSelect && group.MinQuantity === 0) {
                        var sampleOptionItemNone = {
                            CanRemove: true,
                            Category: category.Category,
                            DefaultQuantity: 0,
                            DeletedPrice: 0,
                            DeletedPriceText: "",
                            Price: 0,
                            PriceText: "",
                            PriceWithoutVat: 0,
                            PriceWithoutVatText: "",
                            MinQuantity: 0,
                            MaxQuantity: 1,
                            Weight: 0,
                            Name: "None of below",
                            OrderNumber: 0,
                            Quanta: 1,
                            QuantaText: "",
                            RecipeGroupId: group.Id,
                            RecipeGroupName: group.Name,
                            IngredientId: 0,
                            Stock: 1,
                            TaxClassId: 0,
                            VariantId: 0,
                            IsNullable: true
                        };
                        visualgroup.Items.unshift(sampleOptionItemNone);
                    }

                    $.each(visualgroup.Items, function (indexItem, item) {
                        //fix wrong default value from min-max item quantity
                        group.DefaultQuantities += item.DefaultQuantity;
                        item.HasValidDefaultValues = item.MinQuantity <= item.DefaultQuantity && item.MaxQuantity >= item.DefaultQuantity;
                        item.DefaultQuantity = item.MinQuantity > item.DefaultQuantity ? item.MinQuantity : item.MaxQuantity < item.DefaultQuantity ? item.MaxQuantity : item.DefaultQuantity;
                        item.IsMandatory = item.MinQuantity === item.DefaultQuantity || !item.CanRemove;
                        item.Disabled = (item.MinQuantity === item.DefaultQuantity && item.MaxQuantity === item.DefaultQuantity && item.DefaultQuantity > 0) || !item.CanRemove;
                        item.Checked = item.IsDefault;
                        var ingredient = item;
                        ingredient.GroupId = group.Id;
                        _recipes[recipeId].Ingredients.push(ingredient);
                        if (item.Price <= 0) {
                            item.Price = 0;
                            item.PriceText = "";
                        }
                        if (ingredient.DefaultQuantity > 0) {
                            _recipes[recipeId].RecipeItems.push({
                                RecipeId: recipeId,
                                Category: ingredient.Category,
                                CategoryCode: ingredient.CategoryCode,
                                ManufacturerProductCode: ingredient.ManufacturerProductCode,
                                GroupId: group.Id,
                                IngredientId: ingredient.IngredientId,
                                ProductItemCode: ingredient.RecipeItemCode,
                                ProductItemId: ingredient.RecipeItemId,
                                VariantId: ingredient.VariantId,
                                Name: ingredient.Name || "",
                                Quantity: ingredient.DefaultQuantity,
                                Price: 0,//(Math.round(ingredient.Price * 100) / 100) * ingredient.DefaultQuantity,
                                PriceWithoutVat: 0,
                                TotalPrice: 0,
                                TotalPriceWithoutVat: 0,
                                Weight: ingredient.Weight || 0,
                                IsStandard: ingredient.DefaultQuantity > 0,
                                SubRecipeId: ingredient.SubRecipeId,
                                SubRecipeCode: ingredient.SubRecipeCode
                            });
                        }
                    });
                    group.HasValidDefaultValues = group.MinQuantity <= group.DefaultQuantities && group.MaxQuantity >= group.DefaultQuantities;
                    if (!group.IsMultiSelect && group.DefaultQuantities === 0 && group.MinQuantity === 0) {
                        var defaultItem = visualgroup.Items[0];
                        defaultItem.Checked = true;
                    }
                    _recipes[recipeId].Groups.push(group);
                });
            });
        });

        $.each(_.filter(recipe.Ingredients, function (i) { return i.SubRecipeId && i.SubRecipe; }) || []
            , function (i, s) {
                Vendd.RecipeLibrary.InitRecipe(s.SubRecipe, s.RecipeItemId, force);
            });

        _recipes[recipeId].HashCode = getRecipeItemsHashCode(recipeId);

        if (localStorage.getItem("globalId_" + recipeId) !== null) {
            localStorage.removeItem("globalId_" + recipeId);
        }

        return Vendd.RecipeLibrary.DeclareState(recipe, recipeId);
    };

    Vendd.RecipeLibrary.ResetRecipe = function (model, recipeId) {

        if (!_recipes[recipeId]) {
            return returnResponse(recipeId, 500, 1000);
        }
        var recipe = getRecipe(model, recipeId);

        if (!recipe) {
            return returnResponse(recipeId, 500, 1001);
        }
        //reinitialize
        delete _recipes[recipeId];
        _recipes[recipeId] = recipe;

        if (localStorage.getItem("globalId_" + recipeId) !== null) {
            localStorage.removeItem("globalId_" + recipeId);
        }
        return Vendd.RecipeLibrary.DeclareState(model, recipeId);
    };

    Vendd.RecipeLibrary.AddIngredient = function (model, recipeId, ingredientId, quantity, isTotal) {
        var recipe = _recipes[recipeId];

        if (!_recipes[recipeId]) {
            return returnResponse(recipeId, 500, 1000);
        }

        if (!recipe) {
            return returnResponse(recipeId, 500, 1001);
        }

        var group = null;
        var ingredient = _.find(model.Ingredients, function (i) { return i.IngredientId === ingredientId; });
        if (ingredient) group = _.find(model.Groups, function (g) { return g.Id === ingredient.GroupId; });

        if (!(ingredient && group)) {
            return returnResponse(recipeId, 500, 1003);
        }

        var isCompatible = (Vendd.RecipeLibrary.CheckIncompatibles(recipeId, ingredientId)).success;
        var responsePrerequisites = (Vendd.RecipeLibrary.CheckPrerequisites(recipeId, ingredientId));
        var successPrerequisites = responsePrerequisites.success || (!responsePrerequisites.success && responsePrerequisites.data.BothPrerequisite);

        var recipeIngredient = _.first(_.filter(model.RecipeItems, function (x) { return x.IngredientId === ingredientId && x.RecipeId === recipeId; }));
        if (!isCompatible || !successPrerequisites) {
            var errorCode = !isCompatible && !successPrerequisites ? 1032 : !isCompatible ? 1030 : 1031;
            return returnResponse(recipeId, 500, errorCode);
        }

        var hasPrerequisitesAnyOfSet = (Vendd.RecipeLibrary.CheckPrerequisitesAnyOfSet(recipeId, ingredientId)).success;
        if (!hasPrerequisitesAnyOfSet) {
            return returnResponse(recipeId, 500, 1033);
        }
        var totalIngredientQuantity = isTotal ? quantity : ((recipeIngredient || {}).Quantity || 0) + quantity;
        totalIngredientQuantity = totalIngredientQuantity > 0 ? totalIngredientQuantity : 0;

        if (ingredient.MinQuantity && totalIngredientQuantity < ingredient.MinQuantity) {
            return returnResponse(recipeId, 500, 1010);
        }
        if (ingredient.MaxQuantity && totalIngredientQuantity > ingredient.MaxQuantity) {
            return returnResponse(recipeId, 500, 1011);
        }
        var maxGroupQuantity = group.MaxQuantity || 0;
        var groupQuantity = getGroupQuantity(model, group, ingredientId);

        if (maxGroupQuantity < groupQuantity + totalIngredientQuantity) {
            return returnResponse(recipeId, 500, 1021);
        }
        var maxQuantity = recipe.MaxQuantity || 0;
        var totalQuantity = getTotalQuantity(model, ingredientId);

        if (maxQuantity < totalQuantity + totalIngredientQuantity) {
            return returnResponse(recipeId, 500, 1041);
        }

        var price = (Math.round(ingredient.Price * 100) / 100);//* totalIngredientQuantity;
        var priceWithoutVat = (Math.round(ingredient.PriceWithoutVat * 100) / 100);//* totalIngredientQuantity;


        if (model.ParentRecipeId > 0) {
            var parentModel = Vendd.RecipeLibrary.GetModel(model.ParentRecipeItemId) || {};
            var parentIngredient = _.find(parentModel.Ingredients, function (i) { return i.VariantId === ingredient.VariantId; }) || {};
            if ((parentIngredient.IngredientId || 0) > 0) {
                var recipeAddResult = Vendd.RecipeLibrary.AddIngredient(parentModel, model.ParentRecipeItemId, parentIngredient.IngredientId, ingredient.Quantity, true);
                if (!recipeAddResult.success) {
                    return returnResponse(recipeId, 500, 1034);
                };
            }
        }

        if (recipeIngredient) {
            recipeIngredient.Quantity = totalIngredientQuantity;
            recipeIngredient.Price = price;
            recipeIngredient.PriceWithoutVat = priceWithoutVat;
        } else {
            model.RecipeItems.push({
                RecipeId: recipeId,
                Category: ingredient.Category,
                CategoryCode: ingredient.CategoryCode,
                ManufacturerProductCode: ingredient.ManufacturerProductCode,
                GroupId: group.Id,
                IngredientId: ingredient.IngredientId,
                ProductItemCode: ingredient.RecipeItemCode,
                ProductItemId: ingredient.RecipeItemId,
                VariantId: ingredient.VariantId,
                Name: ingredient.Name || "",
                Quantity: quantity,
                Price: price,
                PriceWithoutVat: priceWithoutVat,
                TotalPrice: Math.max(totalIngredientQuantity - ingredient.DefaultQuantity, 0) * price,
                TotalPriceWithoutVat: Math.max(totalIngredientQuantity - ingredient.DefaultQuantity, 0) * priceWithoutVat,
                Weight: ingredient.Weight,
                IsStandard: ingredient.DefaultQuantity > 0,
                SubRecipeId: ingredient.SubRecipeId,
                SubRecipeCode: ingredient.SubRecipeCode
            });
        }

        model.HashCode = getRecipeItemsHashCode(recipeId);

        //if (ingredient.SubRecipeId > 0) {
        //    var subRecipeModel = Vendd.RecipeLibrary.GetModel(ingredient.RecipeItemId) || {};
        //    _.each(subRecipeModel.RecipeItems || [], function (si) {
        //        var subRecipeIngredient = _.find(model.Ingredients, function (i) { return i.VariantId == si.VariantId; }) || {};
        //        if ((subRecipeIngredient.IngredientId || 0) > 0) {
        //            var subRecipeGroup = _.find(model.Groups, function (g) { return subRecipeIngredient.GroupId == g.Id; });
        //            var recipeAddResult;
        //            if (subRecipeGroup.IsMultiSelect) {
        //                recipeAddResult = Vendd.RecipeLibrary.AddIngredient(model, recipeId, subRecipeIngredient.IngredientId, subRecipeIngredient.Quantity, true);
        //            } else {
        //                var ingredientIdFrom = (_.find(model.RecipeItems, function (i) { return subRecipeIngredient.GroupId == i.GroupId; }) || {}).IngredientId || 0;
        //                if (ingredientIdFrom > 0) {
        //                    recipeAddResult = Vendd.RecipeLibrary.ChangeIngredient(model, recipeId, ingredientIdFrom, subRecipeIngredient.IngredientId);
        //                } else {
        //                    recipeAddResult = Vendd.RecipeLibrary.AddIngredient(model, recipeId, subRecipeIngredient.IngredientId, subRecipeIngredient.Quantity, true);
        //                }
        //            }
        //            if (!recipeAddResult.success) {
        //                var subRecipeRemoveResult = Vendd.RecipeLibrary.RemoveIngredient(subRecipeModel, ingredient.RecipeItemId, si.IngredientId, 0, true, true);
        //                //Vendd.RecipeLibrary.DeclareState(subRecipeModel, ingredient.RecipeItemId);
        //            }
        //        }
        //    });
        //}

        return Vendd.RecipeLibrary.DeclareState(model, recipeId);
    };

    Vendd.RecipeLibrary.RemoveIngredient = function (model, recipeId, ingredientId, quantity, recursive, force) {
        force = force === undefined ? true : force;
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1001);
        }

        var group = null;
        var ingredient = _.find(model.Ingredients, function (i) { return i.IngredientId === ingredientId; });
        if (ingredient) group = _.find(model.Groups, function (g) { return g.Id === ingredient.GroupId; });

        if (!(ingredient && group)) {
            return returnResponse(recipeId, 500, 1003);
        }

        var recipeIngredient = _.first(_.filter(model.RecipeItems, function (x) { return x.IngredientId === ingredientId && x.RecipeId === recipeId; }));

        var totalIngredientQuantity = recursive ? 0 : ((recipeIngredient || {}).Quantity || 0) - quantity;
        totalIngredientQuantity = totalIngredientQuantity > 0 ? totalIngredientQuantity : 0;

        if (ingredient.MinQuantity && totalIngredientQuantity < ingredient.MinQuantity) {
            return returnResponse(recipeId, 500, 1010);
        }

        var minGroupQuantity = group.MinQuantity || 0;
        var groupQuantity = getGroupQuantity(model, group, ingredientId);

        if (minGroupQuantity > groupQuantity + totalIngredientQuantity && !force) {
            return returnResponse(recipeId, 500, 1020);
        }
        var minQuantity = recipe.MinQuantity || 0;
        var totalQuantity = getTotalQuantity(model, ingredientId);

        if (minQuantity > totalQuantity + totalIngredientQuantity && !force) {
            return returnResponse(recipeId, 500, 1040);
        }

        if (recipeIngredient && totalIngredientQuantity > 0) {
            recipeIngredient.Quantity = totalIngredientQuantity;
            recipeIngredient.Price = price;
        } else {
            model.RecipeItems = _.filter(model.RecipeItems, function (x) { return x.IngredientId !== ingredientId; });
        }

        var ingredientsToBeRemoved = _.filter(model.Ingredients,
            function (i) {
                return i.Prerequisites && i.Prerequisites.indexOf(ingredientId) > -1 && model.RecipeItems.some(function (item) { return item.IngredientId === i.IngredientId });
            });

        for (var i = 0; i < ingredientsToBeRemoved.length; i++) {
            Vendd.RecipeLibrary.RemoveIngredient(model, recipeId, ingredientsToBeRemoved[i].IngredientId, null, true, true);
        }

        model.HashCode = getRecipeItemsHashCode(recipeId);

        return Vendd.RecipeLibrary.DeclareState(model, recipeId);

    };

    Vendd.RecipeLibrary.ChangeIngredient = function (model, recipeId, ingredientIdFrom, ingredientIdTo) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1001);
        }

        var groupFrom = null;
        var ingredientFrom = _.find(model.Ingredients, function (i) { return i.IngredientId === ingredientIdFrom; });
        if (ingredientFrom) groupFrom = _.find(model.Groups, function (g) { return g.Id === ingredientFrom.GroupId; });

        if (!(ingredientFrom && groupFrom)) {
            return returnResponse(recipeId, 500, 1003);
        }

        var recipeIngredientFrom = _.first(_.filter(model.RecipeItems, function (x) { return x.IngredientId === ingredientIdFrom && x.RecipeId === recipeId; }));

        if (!recipeIngredientFrom) {
            return returnResponse(recipeId, 500, 1002);
        }
        var totalQuantity = 1;

        model.RecipeItems = _.filter(model.RecipeItems, function (x) { return x.IngredientId !== ingredientIdFrom; });

        var ingredientsToBeRemoved = _.filter(model.Ingredients,
            function (i) {
                return i.Prerequisites && i.Prerequisites.indexOf(ingredientIdFrom) > -1 && model.RecipeItems.some(function (item) { return item.IngredientId === i.IngredientId; });
            });

        var prerequisitesResult = [];

        for (var i = 0; i < ingredientsToBeRemoved.length; i++) {
            prerequisitesResult = Vendd.RecipeLibrary.RemoveIngredient(model, recipeId, ingredientsToBeRemoved[i].IngredientId, null, true, true);
        }

        var result = Vendd.RecipeLibrary.AddIngredient(model, recipeId, ingredientIdTo, 1, true);

        model.HashCode = getRecipeItemsHashCode(recipeId);

        if (result.success) return result;

        return Vendd.RecipeLibrary.DeclareState(model, recipeId);

    };

    Vendd.RecipeLibrary.GetFullRecipeItems = function (recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }

        var recipeItems = recipe.RecipeItems || [];
        _.each(
            _.filter(recipe.Ingredients, function (item) {
                return item.SubRecipeId && (_.find(recipeItems, function (i) { return i.IngredientId === item.IngredientId; }) !== undefined);
            }), function (item) {
                if (!item.IsStandard) {
                    _.each(_recipes[item.RecipeItemId].RecipeItems, function (ingredient) { ingredient.IsStandard = false; });
                }
                recipeItems = recipeItems.concat(_recipes[item.RecipeItemId].RecipeItems);
            });
        var data = {};
        data.RecipeItems = recipeItems || [];
        return returnResponse(recipeId, 200, 0, data);
    };

    Vendd.RecipeLibrary.GetRecipeItems = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }
        var data = {};
        data.RecipeItems = recipe.RecipeItems || [];
        return returnResponse(recipeId, 200, 0, data);
    };

    Vendd.RecipeLibrary.GetOneDealerData = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }
        var data = {};

        data.ManufacturerName = recipe.ManufacturerName || "";
        data.ProductCode = recipe.ManufacturerProductCode || "";
        data.ManufacturerCode = recipe.ManufacturerCode || "";
        data.Series = recipe.CategoryCode || "";
        data.Name = recipe.Name || "";
        data.Guid = localStorage.getItem("globalId_" + recipeId);

        data.Prices = {};
        data.Prices.OptionalTotalPrice = FixJSFloatBug(recipe.Prices.OptionalTotalPriceWithoutVat);
        data.Prices.StandardTotalPrice = FixJSFloatBug(recipe.Prices.StandardTotalPriceWithoutVat);
        data.Prices.InitialPrice = FixJSFloatBug(recipe.Prices.InitialPriceWithoutVat);
        data.Prices.TotalPrice = FixJSFloatBug(recipe.Prices.TotalPriceWithoutVat);

        data.ModelImageAbsoluteUrl = recipe.ProductImageUrl;

        var cartTypeCode = _.find(recipe.Attributes, function (i) { return i.Code === "CarTypeCode"; }) || {};
        data.CarTypeCode = (cartTypeCode.Value || "Car");
        var fuelTypeCode = _.find(recipe.Attributes, function (i) { return i.Code === "FuelTypeCode"; }) || {};
        data.FuelTypeCode = (fuelTypeCode.Value || "");
        var attributes = _.filter(recipe.Attributes, function (i) { return i.Code !== "CarTypeCode" && i.Code !== "FuelTypeCode"; }) || [];
        data.Attributes = _.map(attributes, function (i) {
            var item = {};
            item.AttributeCode = i.Code;
            item.Value = i.Value;
            item.Type = i.ValueType;
            return item;
        });
        var recipeItems = recipe.RecipeItems || [];
        _.each(
            _.filter(recipe.Ingredients, function (item) {
                return item.SubRecipeId && (_.find(recipeItems, function (i) { return i.IngredientId === item.IngredientId; }) !== undefined);
            }), function (item) {
                if (!item.IsStandard) {
                    _.each(_recipes[item.RecipeItemId].RecipeItems, function (ingredient) { ingredient.IsStandard = false; ingredient.SubRecipeCode = item.ManufacturerProductCode; });
                }
                recipeItems = recipeItems.concat(_recipes[item.RecipeItemId].RecipeItems);
            });

        data.RecipeItems = _.map(recipeItems || [], function (i) {
            var item = {};
            item.CategoryCode = i.CategoryCode || "";
            item.Name = i.Name;
            item.Quantity = i.Quantity;
            //item.Price = i.Price;
            item.Price = i.PriceWithoutVat;
            item.ItemCode = i.ManufacturerProductCode || "";
            item.IsPackage = (i.SubRecipeId || 0) > 0;
            item.ParentPackageCode = i.SubRecipeCode || "";
            item.OptionType = i.IsStandard ? 0 : 1;
            return item;
        });
        return returnResponse(recipeId, 200, 0, data);
    };

    Vendd.RecipeLibrary.SetRecipeItems = function (recipeId, recipeItems) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }

        recipe.RecipeItems = recipeItems || [];

        return Vendd.RecipeLibrary.DeclareState(recipe, recipeId);
    };

    Vendd.RecipeLibrary.GetCheckedRecipeItems = function (recipeId, forceOptional) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }
        forceOptional = forceOptional !== undefined ? forceOptional : false;
        //var checkedItems = _.filter(recipe.Ingredients, function (item) { return item.DefaultQuantity > 0; });

        //var checkedRecipeItems = _.filter(recipe.RecipeItems, function (item) { return item.Quantity > 0; });

        var checkedRecipeItems = [];
        var optionalTotalPrice = 0;
        var optionalTotalItems = 0;
        var standardTotalPrice = 0;
        var standardTotalItems = 0;
        var optionalTotalPriceWithoutVat = 0;
        var standardTotalPriceWithoutVat = 0;

        //var deafaultItems = _.filter(recipe.Ingredients, function (item) { return item.DefaultQuantity > 0; });
        $.each(recipe.Ingredients, function (indexInArray, ingredient) {
            var item = _.find(recipe.RecipeItems, function (i) { return i.IngredientId === ingredient.IngredientId && i.Quantity > 0; });
            var groupQuantity = getGroupQuantity(recipe, { Id: ingredient.GroupId }, ingredient.IngredientId);
            var isMultiSelect = (_.find(recipe.Groups, function (group) { return ingredient.GroupId === group.Id; }) || {}).IsMultiSelect;
            var isChecked = item;
            if (!isMultiSelect) {
                var selectedItems = _.filter(recipe.RecipeItems, function (i) { return i.GroupId === ingredient.GroupId; }) || [];
                if (selectedItems.length > 1) {
                    isChecked = isChecked && (selectedItems[0].IngredientId === ingredient.IngredientId);
                }
            }
            var isStandard = forceOptional ? false : (ingredient.IsNullable ? false : ingredient.DefaultQuantity > 0);
            if (isChecked) {
                var price = Math.round(ingredient.Price * 100) / 100;
                var totalPrice = ingredient.DefaultQuantity > 0 ?
                    ((item.Quantity || 0) - (ingredient.DefaultQuantity || 0)) * price :
                    (item.Quantity || 0) * price;
                var priceWithoutVat = Math.round(ingredient.PriceWithoutVat * 100) / 100;
                var totalPriceWithoutVat = ingredient.DefaultQuantity > 0 ?
                    ((item.Quantity || 0) - (ingredient.DefaultQuantity || 0)) * priceWithoutVat :
                    (item.Quantity || 0) * priceWithoutVat;
                checkedRecipeItems.push({
                    RecipeItemId: recipeId,
                    ImageUrl: ingredient.ImageUrl,
                    Category: ingredient.Category,
                    GroupId: ingredient.GroupId,
                    IngredientId: ingredient.IngredientId,
                    ProductItemId: ingredient.RecipeItemId,
                    VariantId: ingredient.VariantId,
                    Name: ingredient.Name || "",
                    //ParentProductId: recipeId,
                    Quantity: item.Quantity,
                    Price: price,
                    PriceWithoutVat: priceWithoutVat,
                    TotalPriceWithoutVat: totalPriceWithoutVat,
                    Weight: ingredient.Weight,
                    IsStandard: isStandard
                });
                if (isStandard) {
                    standardTotalPrice += totalPrice;
                    standardTotalPriceWithoutVat += totalPriceWithoutVat;
                    standardTotalItems++;
                } else {
                    optionalTotalPrice += totalPrice;
                    optionalTotalPriceWithoutVat += totalPriceWithoutVat;
                    optionalTotalItems++;
                }
            }
            if (ingredient.IsNullable) {
                if (groupQuantity === 0) {
                    checkedRecipeItems.push({
                        RecipeItemId: recipeId,
                        ImageUrl: ingredient.ImageUrl,
                        Category: ingredient.Category,
                        GroupId: ingredient.GroupId,
                        IngredientId: ingredient.IngredientId,
                        ProductItemId: ingredient.RecipeItemId,
                        VariantId: ingredient.VariantId,
                        Name: ingredient.Name || "",
                        //ParentProductId: recipeId,
                        Quantity: 1,
                        Price: 0,
                        PriceWithoutVat: 0,
                        TotalPrice: 0,
                        TotalPriceWithoutVat: 0,
                        Weight: 0,
                        IsStandard: isStandard
                    });
                }
            }

            if (item && (item.Quantity || 0) > 0 && ingredient.SubRecipe) {
                var subCheckedRecipeItems = Vendd.RecipeLibrary.GetCheckedRecipeItems(ingredient.RecipeItemId, !isStandard) || {};
                if (subCheckedRecipeItems.success) {
                    item.TotalPrice = subCheckedRecipeItems.data.Prices.TotalPrice;
                    item.TotalPriceWithoutVat = subCheckedRecipeItems.data.Prices.TotalPriceWithoutVat;
                    checkedRecipeItems = (checkedRecipeItems || []).concat(subCheckedRecipeItems.data.CheckedRecipeItems || []);
                    //checkedRecipeItems = _.extend([], checkedRecipeItems, subCheckedRecipeItems.data.CheckedRecipeItems);
                }
            }
        });

        var uncheckedRecipeItems = _.reject(recipe.Ingredients, function (item) { return _.find(checkedRecipeItems, function (checked) { return item.IngredientId === checked.IngredientId; }); });

        var data = {};
        data.CheckedItemsOptionalTotal = optionalTotalItems;
        data.CheckedItemsStandardTotal = standardTotalItems;
        data.CheckedRecipeItems = checkedRecipeItems;
        data.UncheckedRecipeItems = uncheckedRecipeItems;
        data.Prices = {};
        data.Prices.OptionalTotalPrice = optionalTotalPrice;
        data.Prices.OptionalTotalPriceWithoutVat = optionalTotalPriceWithoutVat;
        data.Prices.StandardTotalPrice = standardTotalPrice;
        data.Prices.StandardTotalPriceWithoutVat = standardTotalPriceWithoutVat;
        data.Prices.InitialPrice = recipe.UnitPrice;
        data.Prices.InitialPriceWithoutVat = recipe.UnitPriceWithoutVat;
        data.Prices.TotalPrice = optionalTotalPrice + standardTotalPrice + recipe.UnitPrice;
        data.Prices.TotalPriceWithoutVat = optionalTotalPriceWithoutVat + standardTotalPriceWithoutVat + recipe.UnitPriceWithoutVat;
        recipe.Prices = data.Prices;

        return returnResponse(recipeId, 200, 0, data);

    };

    Vendd.RecipeLibrary.GetPrices = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }

        var prices = {};
        prices.OptionalTotalPrice = 0;
        prices.StandardTotalPrice = 0;
        prices.OptionalTotalPriceWithoutVat = 0;
        prices.StandardTotalPriceWithoutVat = 0;
        _.each(recipe.RecipeItems, function (ri) {
            var ingredient = _.find(recipe.Ingredients, function (i) { return i.IngredientId === ri.IngredientId; }) || {};
            var defaultQuantity = ingredient.DefaultQuantity || 0;
            var initialPrice = Math.round((ingredient.Price || 0) * 100) / 100;
            var initialPriceWithoutVat = Math.round((ingredient.PriceWithoutVat || 0) * 100) / 100;
            var optionalQuantity = Math.max(ri.Quantity - defaultQuantity);
            var optionalTotalPrice = initialPrice * optionalQuantity;
            var optionalTotalPriceWithoutVat = initialPriceWithoutVat * optionalQuantity;
            var standardTotalPrice = 0;//defaultQuantity > 0 ? initialPrice * defaultQuantity : 0;
            var standardTotalPriceWithoutVat = 0;//defaultQuantity > 0 ? initialPrice * defaultQuantity : 0;
            if (ingredient.SubRecipe && ri.Quantity > 0) {
                var subPrices = Vendd.RecipeLibrary.GetPrices(ingredient.RecipeItemId) || {};
                optionalTotalPrice += (subPrices.OptionalTotalPrice || 0);
                optionalTotalPriceWithoutVat += (subPrices.OptionalTotalPriceWithoutVat || 0);
                standardTotalPrice += (subPrices.StandardTotalPrice || 0);
                standardTotalPriceWithoutVat += (subPrices.StandardTotalPriceWithoutVat || 0);
            }
            prices.OptionalTotalPrice += optionalTotalPrice;
            prices.StandardTotalPrice += standardTotalPrice;
            prices.OptionalTotalPriceWithoutVat += optionalTotalPriceWithoutVat;
            prices.StandardTotalPriceWithoutVat += standardTotalPriceWithoutVat;
        });
        prices.InitialPrice = recipe.UnitPrice;
        prices.InitialPriceWithoutVat = recipe.UnitPriceWithoutVat;
        prices.TotalPrice = prices.OptionalTotalPrice + prices.StandardTotalPrice + prices.InitialPrice;
        prices.TotalPriceWithoutVat = prices.OptionalTotalPriceWithoutVat + prices.StandardTotalPriceWithoutVat + prices.InitialPriceWithoutVat;
        recipe.Prices = prices;
        return prices;
    };

    Vendd.RecipeLibrary.GetWeight = function (recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }
        var weightObj = {};
        weightObj.InitialWeight = recipe.Weight || 0;
        weightObj.OptionalTotalWeight = getTotalWeight(recipe, recipeId);
        return weightObj;

    };

    Vendd.RecipeLibrary.GetEnabledItems = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }

        var data = {};
        data.EnabledItems = [];
        data.DisableItems = [];

        data.GroupErrors = [];

        data.Errors = [];

        var totalQuantity = getTotalQuantity(recipe);
        var extraQuantity = 0;
        var errorCode = 0;
        if (totalQuantity < recipe.MinQuantity) {
            errorCode = 1042;
            extraQuantity = recipe.MinQuantity - totalQuantity;
        }
        else if (totalQuantity > recipe.MaxQuantity) {
            errorCode = 1043;
            extraQuantity = totalQuantity - recipe.MaxQuantity;
        }
        if (errorCode > 0) {
            data.Errors.push({
                RecipeId: recipeId,
                ErrorCode: errorCode,
                ExtraQuantity: extraQuantity,
                MinQuantity: recipe.MinQuantity,
                MaxQuantity: recipe.MaxQuantity,
                Quantity: totalQuantity
            });
        }

        //var subRecipeIngredientIds = [];


        //var subRecipes = _.filter(recipe.Ingredients, function (i) {
        //    if (i.SubRecipeId == 0) return false;
        //    return recipe.RecipeItems.some(function (r) { return r.VariantId === i.VariantId; });
        //}) || [];
        //_.each(subRecipes, function (sr) {
        //    var subRecipe = Vendd.RecipeLibrary.GetModel(sr.RecipeItemId) || {};
        //    _.each(subRecipe.Ingredients || [], function (i) {
        //        if (i.VariantId > 0) {
        //            var i_group = _.find(recipe.Groups, function (g) {
        //                return g.Items.some(function (i_g) { return i.VariantId === i_g.VariantId; });
        //            });
        //            if (i_group.IsMultiSelect) {

        //                //var ingredients = recipe.Ingredients.filter(function (item) { return item.VariantId === i.VariantId; });
        //                var ingredients = _.map(
        //                    recipe.Ingredients.filter(function (item) { return item.VariantId === i.VariantId; }),
        //                    function (x) { return x.IngredientId; });
        //            } else {
        //                //var ingredients = i_group.Items;
        //                var ingredients = _.map(i_group.Items, function (item) {
        //                    return item.IngredientId;
        //                });
        //            }
        //            subRecipeIngredientIds = _.uniq(_.union(subRecipeIngredientIds, ingredients));
        //        }
        //    });
        //});

        $.each(recipe.Categories, function (indexCategory, category) {
            $.each(category.Groups, function (indexGroup, group) {
                //group.IsMultiSelect = !(group.MinQuantity <= 1 && group.MaxQuantity == 1 && group.Items.length > 1);
                var groupQuantity = getGroupQuantity(recipe, group);
                var disableAllGroup = _.filter(recipe.Ingredients, function (i) { return i.GroupId === group.Id && !i.CanRemove && !group.IsMultiSelect; }).length > 0;
                $.each(group.VisualGroups, function (indexVisualGroup, visualGroup) {
                    $.each(visualGroup.Items, function (indexItem, ingredient) {
                        var recipeIngredient = _.first(_.filter(recipe.RecipeItems, function (x) { return x.IngredientId === ingredient.IngredientId && x.RecipeId === recipeId; })) || {};
                        var quantity = recipeIngredient.Quantity || 0;
                        //einai project specific gia bjt, prepei na allaxei se general
                        var isDisableFromSubRecipe = false; //subRecipeIngredientIds.some(function (x) { return x == ingredient.IngredientId; });
                        var isDisabled = !ingredient.CanRemove ||
                            (ingredient.MaxQuantity <= quantity && ingredient.MinQuantity > quantity) ||
                            //(group.MinQuantity >= groupQuantity && quantity > 0) ||
                            (group.MaxQuantity <= groupQuantity && quantity === 0) ||
                            //(recipe.MinQuantity >= totalQuantity && quantity > 0) ||
                            (recipe.MaxQuantity <= totalQuantity && quantity === 0)
                            ;
                        var canAdd = ingredient.MaxQuantity > quantity && group.MaxQuantity > groupQuantity;
                        var canRemove = ingredient.MinQuantity < quantity && ingredient.CanRemove;
                        var isChecked = quantity > 0;
                        var checkIncompatibles = (Vendd.RecipeLibrary.CheckIncompatibles(recipeId, ingredient.IngredientId));
                        var isEnabledIncompatible = checkIncompatibles.success || (!checkIncompatibles.success && checkIncompatibles.data.BothSelected);
                        var checkPrerequisites = (Vendd.RecipeLibrary.CheckPrerequisites(recipeId, ingredient.IngredientId));
                        var isEnabledPrerequisites = checkPrerequisites.success || (!checkPrerequisites.success && checkPrerequisites.data.BothPrerequisite);
                        var checkPrerequisitesAnyOfSet = (Vendd.RecipeLibrary.CheckPrerequisitesAnyOfSet(recipeId, ingredient.IngredientId));
                        var errorCode = 0;
                        if (!disableAllGroup && ((!group.IsMultiSelect || !isDisabled) && (isEnabledIncompatible && isEnabledPrerequisites && checkPrerequisitesAnyOfSet.success && !isDisableFromSubRecipe) || ingredient.IsNullable)) {
                            if (isDisabled && ingredient.DefaultQuantity > 0 && ingredient.MinQuantity === ingredient.DefaultQuantity) errorCode = 1012;
                            else if (!checkIncompatibles.success) errorCode = checkIncompatibles.status.ErrorCode;
                            else if (!checkPrerequisites.success) errorCode = checkPrerequisites.status.ErrorCode;
                            else if (!checkPrerequisitesAnyOfSet.success) errorCode = checkPrerequisitesAnyOfSet.status.ErrorCode;
                            data.EnabledItems.push({
                                RecipeId: recipeId,
                                GroupId: group.Id,
                                IngredientId: ingredient.IngredientId,
                                ProductItemId: ingredient.RecipeItemId,
                                VariantId: ingredient.VariantId,
                                ErrorCode: errorCode,
                                CanAdd: canAdd,
                                canRemove: canRemove,
                                Incompatibles: checkIncompatibles.data.Incompatibles,
                                MissingPrerequisites: checkPrerequisites.data.MissingPrerequisites,
                                MissingAnyOfPrerequisites: checkPrerequisitesAnyOfSet.data.MissingAnyOfPrerequisites,
                            });
                        } else {
                            var disableIncompatibles = true;
                            if (isDisabled && ingredient.DefaultQuantity > 0 && ingredient.MinQuantity === ingredient.DefaultQuantity) errorCode = 1012;
                            //else if (group.MinQuantity >= groupQuantity && group.IsMultiSelect && isChecked) errorCode = 1020;
                            else if (group.MaxQuantity <= groupQuantity && group.IsMultiSelect && !isChecked) errorCode = 1021;
                            else if (disableAllGroup) errorCode = 1021;
                            //else if (recipe.MinQuantity >= totalQuantity && group.IsMultiSelect && isChecked) errorCode = 1040;
                            else if (recipe.MaxQuantity <= totalQuantity && group.IsMultiSelect && !isChecked) errorCode = 1041;
                            else if (ingredient.MinQuantity > quantity && group.IsMultiSelect && isChecked) errorCode = 1010;
                            else if (ingredient.MaxQuantity <= quantity && group.IsMultiSelect && !isChecked) errorCode = 1011;
                            else if (!checkIncompatibles.success) errorCode = 1030;
                            else if (!checkPrerequisites.success) errorCode = 1031;
                            else if (!checkPrerequisitesAnyOfSet.success) errorCode = 1033;
                            else if (isDisableFromSubRecipe) errorCode = 1034;
                            if (errorCode > 0) {
                                data.DisableItems.push({
                                    RecipeId: recipeId,
                                    GroupId: group.Id,
                                    IngredientId: ingredient.IngredientId,
                                    ProductItemId: ingredient.RecipeItemId,
                                    VariantId: ingredient.VariantId,
                                    ErrorCode: errorCode,
                                    CanAdd: canAdd,
                                    canRemove: canRemove,
                                    Incompatibles: checkIncompatibles.data.Incompatibles,
                                    MissingPrerequisites: checkPrerequisites.data.MissingPrerequisites,
                                    MissingAnyOfPrerequisites: checkPrerequisitesAnyOfSet.data.MissingAnyOfPrerequisites,

                                });
                            }
                        }
                    });
                });
                var groupErrorCode = 0;
                var extraQuantity = 0;
                if (groupQuantity < group.MinQuantity) {
                    groupErrorCode = 1022;
                    extraQuantity = group.MinQuantity - groupQuantity;
                }
                else if (groupQuantity > group.MaxQuantity) {
                    groupErrorCode = 1023;
                    extraQuantity = groupQuantity - group.MaxQuantity;
                }
                if (groupErrorCode > 0) {
                    data.GroupErrors.push({
                        Id: group.Id,
                        RecipeId: recipeId,
                        ErrorCode: groupErrorCode,
                        ExtraQuantity: extraQuantity,
                        MinQuantity: group.MinQuantity,
                        MaxQuantity: group.MaxQuantity,
                        Quantity: groupQuantity,
                        Name: group.Name,
                        CategoryName: category.Category
                    });
                }
            });
        });

        return returnResponse(recipeId, 200, 0, data);
    };

    Vendd.RecipeLibrary.CheckIncompatibles = function (recipeId, ingredientId) {

        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }

        var ingredient = _.find(recipe.Ingredients, function (i) { return i.IngredientId === ingredientId; });
        var recipeIngredient = _.first(_.filter(recipe.RecipeItems, function (x) { return x.IngredientId === ingredient.IngredientId; })) || {};

        if (!ingredient) {
            return returnResponse(recipeId, 500, 1002);
        }

        var data = {};
        var incompatibles = _.filter(ingredient.Incompatibles,
            function (i) {
                return recipe.RecipeItems.some(function (item) { return item.IngredientId === i; });
            }) || [];

        if (incompatibles.length > 0) {
            data.Incompatibles = _.filter(recipe.Ingredients, function (item) { return incompatibles.some(function (i) { return item.IngredientId === i; }) });
            data.BothSelected = (recipeIngredient.Quantity || 0) > 0;
            return returnResponse(recipeId, 500, 1030, data);
        }

        return returnResponse(recipeId, 200);
    }

    Vendd.RecipeLibrary.CheckPrerequisites = function (recipeId, ingredientId) {

        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }

        var ingredient = _.find(recipe.Ingredients, function (i) { return i.IngredientId === ingredientId });

        if (!ingredient) {
            return returnResponse(recipeId, 500, 1002);
        }

        var data = {};
        var missingPrerequisites = _.filter(ingredient.Prerequisites,
            function (i) {
                return !recipe.RecipeItems.some(function (item) { return item.IngredientId === i; });
            }) || [];

        if (missingPrerequisites.length > 0) {
            data.MissingPrerequisites = _.filter(recipe.Ingredients, function (item) { return missingPrerequisites.some(function (i) { return item.IngredientId === i; }) });
            var bothPrerequisite = _.filter(data.MissingPrerequisites,
                function (i) {
                    return i.Prerequisites.length > 0 && i.Prerequisites.some(function (item) { return item === ingredient.IngredientId; });
                }) || [];
            data.BothPrerequisite = bothPrerequisite.length > 0;
            return returnResponse(recipeId, 500, 1031, data);
        }

        return returnResponse(recipeId, 200);
    }

    Vendd.RecipeLibrary.CheckPrerequisitesAnyOfSet = function (recipeId, ingredientId) {

        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }

        var ingredient = _.find(recipe.Ingredients, function (i) { return i.IngredientId === ingredientId });

        if (!ingredient) {
            return returnResponse(recipeId, 500, 1002);
        }

        var data = {};
        data.MissingAnyOfPrerequisites = [];
        var hasMissingAnyOfPrerequisites = false;
        for (var i = 0; i < (ingredient.RequiresAnyOfSet || []).length; i++) {
            var requiredSetItems = ingredient.RequiresAnyOfSet[i].RequiresAnyOfItems || [];
            var anyOfIngredient = _.filter(requiredSetItems,
                function (i) {
                    return recipe.RecipeItems.some(function (item) { return item.IngredientId === i; });
                }) || [];

            if (anyOfIngredient.length === 0 && requiredSetItems.length > 0) {
                hasMissingAnyOfPrerequisites = true;
                var missingAnyOfPrerequisites = _.filter(recipe.Ingredients, function (item) { return requiredSetItems.some(function (i) { return item.IngredientId === i; }); });
                data.MissingAnyOfPrerequisites.push(missingAnyOfPrerequisites);
            }
        }
        if (hasMissingAnyOfPrerequisites)
            return returnResponse(recipeId, 500, 1033, data);

        return returnResponse(recipeId, 200);
    }

    Vendd.RecipeLibrary.IsValid = function (recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }

        var data = {};
        data.Errors = [];
        data.GroupErrors = [];
        data.IngredientsErrors = [];

        var totalQuantity = getTotalQuantity(recipe, recipeId);
        var extraQuantity = 0;
        var errorCode = 0;
        if (totalQuantity < recipe.MinQuantity) {
            errorCode = 1042;
            extraQuantity = recipe.MinQuantity - totalQuantity;
        }
        else if (totalQuantity > recipe.MaxQuantity) {
            errorCode = 1043;
            extraQuantity = totalQuantity - recipe.MaxQuantity;
        }
        if (errorCode > 0) {
            data.Errors.push({
                ParentProductId: recipeId,
                ErrorCode: errorCode,
                ExtraQuantity: extraQuantity,
                MinQuantity: recipe.MinQuantity,
                MaxQuantity: recipe.MaxQuantity,
                Quantity: totalQuantity
            });
        }

        $.each(recipe.Categories, function (indexCategory, category) {
            $.each(category.Groups, function (indexGroup, group) {
                var groupErrorCode = 0;
                var extraQuantity = 0;
                var groupQuantity = getGroupQuantity(recipe, group);
                if (groupQuantity < group.MinQuantity) {
                    groupErrorCode = 1022;
                    extraQuantity = group.MinQuantity - groupQuantity;
                }
                else if (groupQuantity > group.MaxQuantity) {
                    groupErrorCode = 1023;
                    extraQuantity = groupQuantity - group.MaxQuantity;
                }
                if (groupErrorCode > 0) {
                    data.GroupErrors.push({
                        Id: group.Id,
                        RecipeId: recipeId,
                        ErrorCode: groupErrorCode,
                        ExtraQuantity: extraQuantity,
                        MinQuantity: group.MinQuantity,
                        MaxQuantity: group.MaxQuantity,
                        Quantity: groupQuantity,
                        Name: group.Name,
                        CategoryName: category.Category
                    });
                }
                $.each(group.VisualGroups, function (indexVisualGroup, visualGroup) {
                    $.each(visualGroup.Items, function (indexItem, ingredient) {
                        var recipeIngredient = _.first(_.filter(recipe.RecipeItems, function (x) { return x.IngredientId === ingredient.IngredientId; })) || _.find(recipe.RecipeItems, function (i) { return ingredient.RecipeItemId === i.RecipeItemId; }) || {};
                        var quantity = recipeIngredient.Quantity || 0;
                        var checkIncompatibles = (Vendd.RecipeLibrary.CheckIncompatibles(recipeId, ingredient.IngredientId));
                        var checkPrerequisites = (Vendd.RecipeLibrary.CheckPrerequisites(recipeId, ingredient.IngredientId));
                        var checkPrerequisitesAnyOfSet = (Vendd.RecipeLibrary.CheckPrerequisitesAnyOfSet(recipeId, ingredient.IngredientId));
                        var errorCodes = [];
                        if (ingredient.MinQuantity > quantity) errorCodes.push(1010);
                        else if (ingredient.MaxQuantity < quantity) errorCodes.push(1011);
                        else if (!checkIncompatibles.success && quantity > 0) errorCodes.push(1030);
                        else if (!checkPrerequisites.success && quantity > 0) errorCodes.push(1031);
                        else if (!checkPrerequisitesAnyOfSet.success && quantity > 0) errorCodes.push(1033);
                        if (errorCodes.length > 0) {
                            data.IngredientsErrors.push({
                                RecipeId: recipeId,
                                GroupId: group.Id,
                                IngredientId: ingredient.IngredientId,
                                ErrorCodes: errorCodes,
                                Incompatibles: checkIncompatibles.data.Incompatibles || [],
                                MissingPrerequisites: checkPrerequisites.data.MissingPrerequisites || [],
                                MissingAnyOfPrerequisites: checkPrerequisitesAnyOfSet.data.MissingAnyOfPrerequisites || [],
                                Name: ingredient.Name || "",
                                Price: ingredient.Price,
                                PriceWithoutVat: ingredient.PriceWithoutVat,
                                PriceText: ingredient.PriceText,
                                PriceWithoutVatText: ingredient.PriceWithoutVatText,
                                TotalPrice: ingredient.TotalPrice,
                                TotalPriceWithoutVat: ingredient.TotalPriceWithoutVat

                            });
                        }
                    });
                });
            });
        });
        data.IsValid = data.Errors.length === 0 && data.GroupErrors.length === 0 && data.IngredientsErrors.length === 0;
        return data;
    }

    Vendd.RecipeLibrary.CompareModels = function (recipeId, savedModel) {

        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }

        //ingredients hash code
        var ingedientsSavedModel = _.sortBy(savedModel.Ingredients, function (i) { return i.IngredientId; });
        var ingedientTemplate = "{0}_{1}_{2}_{3}_{4}";
        var ingedientsSavedModelHashCode = _.map(ingedientsSavedModel,
            function (i) {
                return ingedientTemplate
                    .replace("{0}", i.IngredientId || "")
                    .replace("{1}", i.GroupId || "")
                    .replace("{2}", i.Price || "")
                    .replace("{3}", (i.Incompatibles || []).join(","))
                    .replace("{4}", (i.Prerequisites || []).join(","));
            }).join("|");
        var ingedientsModel = _.sortBy(recipe.Ingredients, function (i) { return i.IngredientId; });
        var ingedientsModelHashCode = _.map(ingedientsModel,
            function (i) {
                return ingedientTemplate
                    .replace("{0}", i.IngredientId || "")
                    .replace("{1}", i.GroupId || "")
                    .replace("{2}", i.Price || "")
                    .replace("{3}", (i.Incompatibles || []).join(","))
                    .replace("{4}", (i.Prerequisites || []).join(","));
            }).join("|");

        //groups hash code
        var groupTemplate = "{0}_{1}";
        var groupsSavedModel = _.sortBy(savedModel.Groups, function (i) { return i.Id; });
        var savedGroupsModelHashCode = _.map(groupsSavedModel,
            function (i) {
                return groupTemplate
                    .replace("{0}", i.MinQuantity || 0)
                    .replace("{1}", i.MaxQuantity || 0);
            }).join("|");
        var groupsModel = _.sortBy(recipe.Groups, function (i) { return i.Id; });
        var groupsModelHashCode = _.map(groupsModel,
            function (i) {
                return groupTemplate
                    .replace("{0}", i.MinQuantity || 0)
                    .replace("{1}", i.MaxQuantity || 0);
            }).join("|");

        //models hash code
        var modelTemplate = "{0}_{1}_{2}_{3}";
        var savedModelHashCode = modelTemplate
            .replace("{0}", savedModel.MinQuantity || 0)
            .replace("{1}", savedModel.MaxQuantity || 0)
            .replace("{2}", savedModel.MaxFreeQuantity || 0)
            .replace("{3}", savedModel.MaxReplaceQuantity || 0);
        var modelHashCode = modelTemplate
            .replace("{0}", recipe.MinQuantity || 0)
            .replace("{1}", recipe.MaxQuantity || 0)
            .replace("{2}", recipe.MaxFreeQuantity || 0)
            .replace("{3}", recipe.MaxReplaceQuantity || 0);

        //modelHashCode = ""; //<----remove this , is test data and only
        if (ingedientsSavedModelHashCode === ingedientsModelHashCode && groupsModelHashCode === savedGroupsModelHashCode && savedModelHashCode === modelHashCode)
            return returnResponse(recipeId, 200);

        var recipeItems = [];
        var IngredientsErrors = [];
        var IngredientsWarnings = [];
        var data = {};
        _.each(savedModel.RecipeItems, function (r) {
            var ingredient = _.find(recipe.Ingredients, function (i) { return r.IngredientId === i.IngredientId; }) || _.find(recipe.Ingredients, function (i) { return r.RecipeItemId === i.RecipeItemId; });
            var savedIngredient = _.find(savedModel.Ingredients, function (i) { return r.IngredientId === i.IngredientId; }) || _.find(savedModel.Ingredients, function (i) { return r.RecipeItemId === i.RecipeItemId; });
            if (ingredient === null) {
                IngredientsErrors.push({
                    IngredientId: savedIngredient.IngredientId,
                    Name: savedIngredient.Name,
                    Price: savedIngredient.Price,
                    Incompatibles: savedIngredient.Incompatibles,
                    Prerequisites: savedIngredient.Prerequisites,
                    ErrorCodes: [1072]
                });
                return;
            }
            if (ingredient.Price !== savedIngredient.Price) {
                IngredientsWarnings.push({
                    IngredientId: savedIngredient.IngredientId,
                    Name: savedIngredient.Name,
                    Price: savedIngredient.Price,
                    Incompatibles: savedIngredient.Incompatibles,
                    Prerequisites: savedIngredient.Prerequisites,
                    ErrorCodes: [1073]
                });
            }
            recipeItems.push({
                RecipeId: recipeId,
                Category: ingredient.Category,
                CategoryCode: ingredient.CategoryCode,
                GroupId: ingredient.GroupId,
                IngredientId: ingredient.IngredientId,
                ProductItemCode: ingredient.RecipeItemCode,
                ProductItemId: ingredient.RecipeItemId,
                VariantId: ingredient.VariantId,
                Name: ingredient.Name || "",
                Quantity: (savedIngredient.Quantity || 1),
                Price: savedIngredient.Price,
                TotalPrice: Math.max((savedIngredient.Quantity || 1) - ingredient.DefaultQuantity, 0) * savedIngredient.Price,
                Weight: ingredient.Weight,
                IsStandard: ingredient.DefaultQuantity > 0,
                SubRecipeId: ingredient.SubRecipeId,
                SubRecipeCode: ingredient.SubRecipeCode
            });
        });

        var checkModel = $.extend({}, recipe);
        recipe.RecipeItems = _.reject(recipeItems, function (r) { return IngredientsErrors.some(function (i) { return i.IngredientId === r.IngredientId; }); });

        var validatedModel = Vendd.RecipeLibrary.IsValid(recipeId);

        data.IngredientsErrors = validatedModel.IngredientsErrors.concat(IngredientsErrors);
        data.IngredientsWarnings = IngredientsWarnings;

        data = $.extend({}, validatedModel, data || {});
        if (!data.IsValid || data.IngredientsErrors.length > 0 || data.GroupErrors.length > 0 || data.Errors.length > 0) {
            return returnResponse(recipeId, 500, 1004, data);
        }
        return returnResponse(recipeId, 200);
    }
    /*
     * GET GLOBAL ID CONFIGURATION
     * RecipeId         the receipe identifier
     * Force            if true, although that mighth be cached global id , it will create a new one - default value:false,
     * FriendlyName     a friendly name for saving - default value: empty,
     * Vin              the vin number - default value: empty,
     * PartnerId        the vin number - default value: empty,
     * serviceurl       the url service - default value: '/services/api/Product/SaveRecipeConfiguration',
     * onSuccess        the function of success saving global identifier,
     * onError          the function of error saving global identifier,
     */
    Vendd.RecipeLibrary.GenerateGlobalId = function (config) {

        var _def = $.Deferred();
        var data = {};

        var defaultConfiguration = {
            Force: false,
            FriendlyName: "",
            Vin: "",
            PartnerId: "",
            serviceurl: "/services/api/Product/SaveRecipeConfiguration"
        };

        defaultConfiguration.onSuccess = function (response) {
            if (!response.success || !response.data || !response.data.GlobalId) {
                config.onError(response);
                return;
            }
            data.GlobalId = response.data.GlobalId;
            data.SavedGlobalIdToLocal = (Vendd.RecipeLibrary.SaveGlobalIdToLocal(config.RecipeId, data.GlobalId)).success;
            data.SaveRecipeItemsToLocal = (Vendd.RecipeLibrary.SaveRecipeItemsToLocal(config.RecipeId, data.GlobalId)).success;
            data.HashCode = getRecipeItemsHashCode(config.RecipeId, recipe.RecipeItems);
            _recipes[config.RecipeId].HashCode = data.HashCode;
            _def.resolve(returnResponse(config.RecipeId, 200, 0, data));
        };
        defaultConfiguration.onError = function (response) {
            _def.reject(returnResponse(config.RecipeId, 500, 1060, response));
        };

        config = $.extend({}, defaultConfiguration, config || {});

        if (!config.RecipeId) {
            _def.resolve(returnResponse(null, 500, 1061));
            return;
        }
        var recipe = _recipes[config.RecipeId];
        if (!recipe) {
            _def.resolve(returnResponse(config.RecipeId, 500, 1000));
            return;
        }

        var currentHashCode = getRecipeItemsHashCode(config.RecipeId);
        var savedHashCode = Vendd.RecipeLibrary.GetLocalStorageRecipeItemsHashCode(config.RecipeId);
        config.HtmlData.Body = "";

        if (!config.Force && localStorage.getItem("globalId_" + config.RecipeId) !== null && currentHashCode === savedHashCode) {
            data.GlobalId = localStorage.getItem("globalId_" + config.RecipeId);
            data.HashCode = currentHashCode;
            _recipes[config.RecipeId].HashCode = currentHashCode;
            _def.resolve(returnResponse(config.RecipeId, 200, 0, data));
        } else {
            var jsonData = (Vendd.RecipeLibrary.ConvertToSavedModel(config.RecipeId) || {}).data || {};
            var requestData = JSON.stringify({
                FriendlyName: config.FriendlyName,
                ConfigurationJson: JSON.stringify(jsonData),
                ProductItemId: config.RecipeId,
                ProductIdentifier: config.Vin,
                PartnerId: config.PartnerId !== "" ? config.PartnerId : null,
                Url: window.location.href,
                HtmlData: config.HtmlData,
                IsShare: !config.Force
            });
            $.ajax({
                type: "POST",
                dataType: 'json',
                contentType: 'application/json; charset=UTF-8',
                url: config.serviceurl,
                async: true,
                data: requestData,
                error: config.onError,
                success: config.onSuccess
            });
        }

        return _def.promise();
    };

    Vendd.RecipeLibrary.AssignConfigurationToUser = function (config) {

        var _def = $.Deferred();
        var data = {};

        var defaultConfiguration = {
            serviceurl: "/services/api/Product/SaveRecipeConfiguration"
        };

        defaultConfiguration.onSuccess = function (response) {
            if (!response.success) {
                config.onError(response);
                return;
            }
            _def.resolve(returnResponse(config.RecipeId, 200, 0, data));
        };
        defaultConfiguration.onError = function (response) {
            _def.reject(returnResponse(config.RecipeId, 500, 1060, response));
        };

        config = $.extend({}, defaultConfiguration, config || {});

        var requestData = JSON.stringify({
            GlobalId: config.GlobalId || "",
            FriendlyName: "Update User",
            ConfigurationJson: JSON.stringify({}),
            ProductItemId: config.RecipeItemId,
            Url: window.location.href,
        });
        $.ajax({
            type: "POST",
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            url: config.serviceurl,
            async: true,
            data: requestData,
            error: config.onError,
            success: config.onSuccess
        });

        return _def.promise();
    };

    Vendd.RecipeLibrary.LoadFromGlobalId = function (config) {
        var _def = $.Deferred();
        var data = {};

        var defaultConfiguration = {
            serviceurl: "/services/api/Product/GetRecipeConfiguration"
        };

        defaultConfiguration.onSuccess = function (response) {
            if (!response.success || !response.data || !response.data.GlobalId) {
                config.onError(data);
                return;
            }
            data = JSON.parse(response.data.ConfigurationJson || "{}");
            data.GlobalId = response.data.GlobalId;
            data.HtmlData = JSON.parse(response.data.Html || "{}");
            data.Pdf = response.data.Pdf || "";
            data.IsValid = true;
            data.Errors = [];
            data.GroupErrors = [];
            data.IngredientsErrors = [];
            data.IngredientsWarnings = [];

            recipe.RecipeItems = data.RecipeItems;
            var compareResult = Vendd.RecipeLibrary.CompareModels(config.RecipeId, data);
            var subrecipeCompareResults = _.map(data.SubRecipes || [], function (subrecipeData) {
                Vendd.RecipeLibrary.SetRecipeItems(subrecipeData.RecipeItemId, subrecipeData.RecipeItems);
                return Vendd.RecipeLibrary.CompareModels(subrecipeData.RecipeItemId, subrecipeData);
            });
            //console.log("compareResult:", compareResult);
            if (!compareResult.success || subrecipeCompareResults.some(function (r) { return !r.success; })) {
                recipe.IsValid = false;
                recipe.IngredientsErrors = compareResult.data.IngredientsErrors;
                recipe.IngredientsWarnings = compareResult.data.IngredientsWarnings;
                recipe.Errors = compareResult.data.Errors;
                recipe.GroupErrors = compareResult.data.GroupErrors;
                //data.RecipeItems = recipe.RecipeItems;
                _def.resolve(returnResponse(config.RecipeId, 200, 1070, recipe));
                return;
            }

            recipe.GlobalId = data.GlobalId;
            recipe.Pdf = data.Pdf;
            recipe.IsValid = data.IsValid;
            recipe.Errors = data.Errors;
            recipe.IngredientsErrors = data.IngredientsErrors;
            recipe.IngredientsWarnings = data.IngredientsWarnings;

            _def.resolve(returnResponse(config.RecipeId, 200, 0, recipe));
            return;
        };
        defaultConfiguration.onError = function (data) {
            _def.reject(returnResponse(config.RecipeId, 500, 1070, data));
            return;
        };

        config = $.extend({}, defaultConfiguration, config || {});

        var recipe = _recipes[config.RecipeId];
        if (!recipe) {
            _def.resolve(returnResponse(config.RecipeId, 500, 1000));
            return;
        }

        if ((config.GlobalId || 0) === 0) {
            _def.resolve(returnResponse(config.RecipeId, 500, 1071));
            return;
        }

        var requestData = JSON.stringify({
            GlobalId: config.GlobalId
        });
        $.ajax({
            type: "POST",
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            url: config.serviceurl,
            async: true,
            data: requestData,
            error: config.onError,
            success: config.onSuccess
        });

        return _def.promise();
    };

    Vendd.RecipeLibrary.SaveGlobalIdToLocal = function (recipeId, globalId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }

        localStorage.setItem("globalId_" + recipeId, globalId);

        return returnResponse(recipeId, 200, 0);
    };

    Vendd.RecipeLibrary.SaveRecipeItemsToLocal = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }
        var recipeItemsData = Vendd.RecipeLibrary.GetFullRecipeItems(recipeId);
        var recipeItems = recipeItemsData.RecipeItems;
        var currentHashCode = getRecipeItemsHashCode(recipeId, recipeItems);
        var savedHashCode = Vendd.RecipeLibrary.GetLocalStorageRecipeItemsHashCode(recipeId);
        if (currentHashCode === savedHashCode) {
            return returnResponse(recipeId, 200);
        }

        var dataLocalStorage = {
            RecipeItems: recipe.RecipeItems,
            HashCode: currentHashCode
        };

        localStorage.setItem("configurator_" + recipeId, JSON.stringify(dataLocalStorage, null, 2));

        return returnResponse(recipeId, 200);
    };

    Vendd.RecipeLibrary.LoadFromLocalRecipeItems = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }
        if (localStorage.getItem("configurator_" + recipeId) === null) {
            return returnResponse(recipeId, 500, 1050);
        }
        //var savedData = $.cookie("model_recipe_" + recipeId) || [];
        var dataLocalStorage = JSON.parse(localStorage.getItem("configurator_" + recipeId) || "{}");
        recipe.RecipeItems = dataLocalStorage.RecipeItems;
        recipe.HashCode = dataLocalStorage.HashCode;

        var data = {};
        data.Recipe = recipe;
        data.GlobalId = "";
        return returnResponse(recipeId, 200, 0, data);
    };

    var getRecipeItemsHashCode = function (recipeId, items) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return null;
        }
        var recipeItems = items || ((Vendd.RecipeLibrary.GetFullRecipeItems(recipeId) || {}).data || {}).RecipeItems;
        var hashCode = recipeId +
            (recipeItems.length > 0
                ? "_" + (_.map(_.sortBy(recipeItems, "IngredientId"), function (i) { return i.IngredientId + "_" + i.Quantity; }) || []).join("_")
                : "");
        return hashCode;
    };

    Vendd.RecipeLibrary.GetLocalStorageRecipeItemsHashCode = function (recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return null;
        }
        if (localStorage.getItem("configurator_" + recipeId) === null) {
            return null;
        }
        var dataLocalStorage = JSON.parse(localStorage.getItem("configurator_" + recipeId) || "{}");
        return dataLocalStorage.HashCode;
    }

    Vendd.RecipeLibrary.ClearLocalStorage = function (recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return false;
        }
        if (localStorage.getItem("configurator_" + recipeId) !== null) {
            localStorage.removeItem("configurator_" + recipeId);
        }
        if (localStorage.getItem("globalId_" + recipeId) !== null) {
            localStorage.removeItem("globalId_" + recipeId);
        }
        return true;
    }

    Vendd.RecipeLibrary.ConvertToSavedModel = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, 1000);
        }
        var data = {};
        data = converModelToSaveDataModel(recipe) || {};
        data.Groups = converGroupsToSaveDataModel(recipe.Groups) || [];
        data.Ingredients = converIngedientToSaveDataModel(recipe.Ingredients) || [];
        data.RecipeItems = Vendd.RecipeLibrary.GetRecipeItems(recipeId).data.RecipeItems || [];
        data.SubRecipes = _.map(
            _.filter(recipe.RecipeItems, function (r) { return r.SubRecipeId > 0 && _recipes[r.ProductItemId]; }) || [],
            function (ri) {
                return (Vendd.RecipeLibrary.ConvertToSavedModel(ri.ProductItemId) || {}).data || {};
            }) || [];
        return returnResponse(recipeId, 200, 0, data);
    };

    var converModelToSaveDataModel = function (m) {
        return {
            RecipeId: m.RecipeId,
            RecipeItemId: m.RecipeItemId,
            MinQuantity: m.MinQuantity,
            MaxQuantity: m.MaxQuantity,
            MaxFreeQuantity: m.MaxFreeQuantity,
            MaxReplaceQuantity: m.MaxReplaceQuantity,
            UnitPrice: m.UnitPrice
        };
    };

    var converGroupsToSaveDataModel = function (groups) {
        var model = _.map(groups, function (g) {
            return {
                Id: g.Id,
                MinQuantity: g.MinQuantity,
                MaxQuantity: g.MaxQuantity,
            };
        });
        return model;
    };

    var converIngedientToSaveDataModel = function (ingredients) {
        var model = _.map(ingredients, function (i) {
            return {
                IngredientId: i.IngredientId,
                Name: i.Name,
                GroupId: i.GroupId,
                Price: i.Price,
                Incompatibles: i.Incompatibles || [],
                Prerequisites: i.Prerequisites || [],
            };
        });
        return model;
    };

    function checkRestrictions(recipe) {
        return true;
    };

    function FixJSFloatBug(price) {
        return parseFloat((price || 0).toFixed(2));
    }

    Vendd.RecipeLibrary.Tests = {
        0: function () {
            var _rec = 2;
            console.log(Vendd.RecipeLibrary.InitRecipe(null, _rec));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, _rec, 88694, 2));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, _rec, 88691, 1));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, _rec, 88691, 2));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, _rec, 88691, 2, true));
            console.log(Vendd.RecipeLibrary.RemoveIngredient(null, _rec, 88694));
            console.log(Vendd.RecipeLibrary.DeclareState(null, _rec));
            return "success";
        },
        1: function () {
            console.log(Vendd.RecipeLibrary.InitRecipe(null, 1));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88691, 2));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88694, 1));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88694, 2));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88694, 2, true));
            console.log(Vendd.RecipeLibrary.RemoveIngredient(null, 1, 88691));
            console.log(Vendd.RecipeLibrary.DeclareState(null, 1));
            return "success";
        },
        2: function () {
            console.log(Vendd.RecipeLibrary.InitRecipe(null, 1));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88694, 1));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88691, 2));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88694, 2));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88694, 2, true));
            console.log(Vendd.RecipeLibrary.RemoveIngredient(null, 1, 88691));
            console.log(Vendd.RecipeLibrary.DeclareState(null, 1));
            return "success";
        }
    };
    return Vendd;

})(Vendd || {});

var testModel = {};
